import config from 'config';
import Model from 'lib/Model';
import { Geolocation } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

export default Model.extend({
	defaults: {
		latitude: null,
		longitude: null,
		accuracy: null,
		error: null,
	},

	watcher: null,


	// À l'initialisation, on écoute l'évenement de geolocalisation
	// On lance un coup de géolocalisation pour définir une position à l'ouverture
	initialize: function()
	{
// 		this.getAccuratePosition();
// 		this.startWatching();
	},


	startWatching: function()
	{
		if( !this.watcher )
		{
			var options = config.geolocation;
			var self = this;

			if( Capacitor.isNativePlatform() )
			{
				Geolocation.watchPosition( options, function( position, error )
				{
					if( error )
					{
						self._onWatchError( error );
					}
					else
					{
						self._onWatchSuccess( position );
					}
				} ).then(function( id )
				{
					self.watcher = id;
					console.log( 'geolocation.startWatching', id );
				});
			}
			else
			{
				this.watcher = navigator.geolocation.watchPosition(
					_.bind( this._onWatchSuccess, this ),
					_.bind( this._onWatchError, this ),
					options
				);
				console.log( 'geolocation.startWatching' );
			}
		}
	},


	stopWatching: function()
	{
		if( this.watcher )
		{
			if( Capacitor.isNativePlatform() )
			{
				Geolocation.clearWatch({ id: this.watcher });
			}
			else
			{
				navigator.geolocation.clearWatch( this.watcher );
			}
			console.log( 'geolocation.stopWatching' );
		}
		this.watcher = null;
	},


	// Success du watcher
	// => On annule les autres appels potentiels à la géolocalisation
	_onWatchSuccess: function( position )
	{
// 		this.startWatching.cancel();
		this._onPositionSuccess( position );
	},


	// Traduit le résultat de navigator.geolocation
	_onPositionSuccess: function( position )
	{
		console.log( 'Geolocation.position', position );

		this.set( _.extend( { located: true, error: null, timestamp: position.timestamp }, position.coords ) );

		// On averti de la nouvelle coordonnée
		this.trigger( 'latlng', this.getLatLng() );

		// On annule les autres appels potentiels à la géolocalisation
//		this.startWatching.cancel();
	},



	// Erreur du watcher !
	// => redemander la géolocalisation (avec une fonction en _.throttle)
	_onWatchError: function( error )
	{
// 		this.startWatching();
		this._onPositionError( error );
	},

	// Erreur de géolocalisation
	// => Alerter…
	_onPositionError: function( error )
	{
		console.error( 'Geolocation.error', JSON.stringify( error ) );

		var message = this._geolocationErrorMessage( error );

		this.set({
			located: false,
			error: message,
		});
		this.trigger( 'error', this.get('error') );

		app.addMessage( message, 'error' );
	},

	// Traduit les erreurs de géolocalisation en messages utilisateurs
	_geolocationErrorMessage: function( error )
	{
		switch( error.code )
		{
			case 1: return "Veuillez autoriser la géolocalisation";
			case 2: return "La géolocalisation a échouée";
			case 3: return "La géolocalisation a dépassée le délai imparti";
			default: return error.message || "Erreur de géolocalisation";
		}
	},



	isLocated: function()
	{
		return this.get('located') && this.has('latitude') && this.has('longitude');
	},

	// On récupère la position sous la forme d'un object destiné à la librairie Turf
	getLatLng: function()
	{
		return { lat: this.get('latitude'), lng: this.get('longitude') };
	},

	// Message d'erreur à afficher (ou défaut)
	getError: function( defaultMessage )
	{
		return this.get('error') || defaultMessage || 'Erreur de géolocalisation';
	},
/*
	getAccuratePosition: _.throttle( function( options )
	{
		var deferred = $.Deferred();

		this.once( 'latlng', deferred.resolve );
		this.once( 'error', deferred.reject );

		app.set( 'geolocating', true );
		deferred.always( function()
		{
			app.set( 'geolocating', false );
		})

		navigator.geolocation.getCurrentPosition( _.bind( this._onPositionSuccess, this ), _.bind( this._onPositionError, this ), config.geolocation )

		return deferred;
	}, config.geolocation.timeout || 5*1000, { trailing: false } )*/
});
